import { globalPackageClasses } from 'shared/helpers/constants/packages/packageClasses';

const isGlobalCreatedPackage = ({ packageClass }) =>
  Object.values(globalPackageClasses).includes(packageClass);

export { isGlobalCreatedPackage };
